// Archetype registry — single source of truth for the code-defined
// block kinds. The map is built once and consumed by:
//   - admin Block Library editor (palette + per-archetype config form)
//   - portal <CompoundStep> (resolves libraryEntry.archetype → component)
//   - validation (every libraryEntry.archetype must resolve here)
import { FormFieldArchetype } from './FormField.js';
import { ChoiceArchetype } from './Choice.js';
import { MarkdownArchetype } from './Markdown.js';
import { ImageArchetype } from './Image.js';
import { ContainerArchetype } from './Container.js';
import { AddressFieldArchetype } from './AddressField.js';
import { PlanPickerArchetype } from './PlanPicker.js';
import { QuizArchetype } from './Quiz.js';
import { UpsellOfferArchetype } from './UpsellOffer.js';
import { ReviewArchetype } from './Review.js';
import { CompletedArchetype } from './Completed.js';
import { StripePaymentArchetype } from './StripePayment.js';
import { OtpVerificationArchetype } from './OtpVerification.js';
export const ARCHETYPES = {
    FormField: FormFieldArchetype,
    Choice: ChoiceArchetype,
    Markdown: MarkdownArchetype,
    Image: ImageArchetype,
    Container: ContainerArchetype,
    AddressField: AddressFieldArchetype,
    PlanPicker: PlanPickerArchetype,
    Quiz: QuizArchetype,
    UpsellOffer: UpsellOfferArchetype,
    Review: ReviewArchetype,
    Completed: CompletedArchetype,
    StripePayment: StripePaymentArchetype,
    OtpVerification: OtpVerificationArchetype,
};
export const ARCHETYPE_MAP = new Map(Object.entries(ARCHETYPES));
export function listArchetypes() {
    return Object.values(ARCHETYPES);
}
export function getArchetype(name) {
    return ARCHETYPE_MAP.get(name);
}
export { FormFieldArchetype, ChoiceArchetype, MarkdownArchetype, ImageArchetype, ContainerArchetype, AddressFieldArchetype, PlanPickerArchetype, QuizArchetype, UpsellOfferArchetype, ReviewArchetype, CompletedArchetype, StripePaymentArchetype, OtpVerificationArchetype, };
